async function openCheckoutWindow( sessionInfo ) {
  window.open( sessionInfo.url );
}

export {
  openCheckoutWindow,
}

export default {
  openCheckoutWindow,
}
